import { classNames } from '@axo/shared/util/dom';
import { MenuNode } from './menuNode';
import styles from './styles.module.css';
import { useApplicationsDetails } from '@axo/shared/data-access/hooks';
import { useContext } from 'react';
import { ApplicationContext } from '../../../store/context';
import { useLockAndOpenApplication } from '../../../hooks/utils/useLockAndOpenApplication';
import { useAssignedApplicationIds } from '../../../hooks/utils/useAssignedApplicationIds';
import { TreeNodeInfo } from '@blueprintjs/core';
import { useNavigate } from 'react-router-dom';

export function useMyPortfolioNodes(): MenuNode[] {
  const navigate = useNavigate();
  const { state } = useContext(ApplicationContext);
  const openAndLock = useLockAndOpenApplication(state.marketCountry ?? '');
  const assignedApplicationIds = useAssignedApplicationIds(
    state.marketCountry ?? '',
  );

  const applicationsData = useApplicationsDetails(assignedApplicationIds);

  const unopenedApps = applicationsData?.filter(
    (app) => app.data && !(app.data.ID in state.openApplications),
  );

  return [
    {
      id: '1C0CFD0D-18A9-41B0-9E69-2406FA711429',
      hasCaret: true,
      icon: 'mugshot',
      label: 'My portfolio',
      className: styles.clickable,
      secondaryLabel: `(${applicationsData.length})`,
      childNodes: [
        ...(applicationsData.filter((x) => !!x.data) ?? []).map<
          TreeNodeInfo<{ onClick: () => void }>
        >((x) => ({
          id: x.data.ID,
          label: x.data.HumanReadableID ?? x.data.ID,
          className: styles.clickable,
          nodeData: {
            onClick() {
              navigate(`/application/${x.data.ID}`);
            },
          },
        })),
        {
          id: 'open-all-portfolio',
          label: `Open all (${unopenedApps.length}/${applicationsData.length})`,
          className: classNames(styles.clickable, styles.action),
          icon: 'open-application',
          disabled: unopenedApps.length === 0,
          nodeData: {
            onClick: () => {
              return Promise.all(
                unopenedApps
                  .filter((app) => !!app.data)
                  .map((app) => ({
                    HumanReadableID: app.data.HumanReadableID ?? '',
                    LoanApplicationID: app.data.ID,
                  }))
                  .map(openAndLock),
              );
            },
          },
        },
      ],
    },
  ];
}
